// ----------------------------------------------------------------------
// <copyright file="Izenda.Droppable.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
/** http://gaearon.github.io/react-dnd/docs-overview.html */

!(function() {
  var m = require('mobx-react');
  var React = require('react');
  var ReactDOM = require('react-dom');
  var DropTarget = require('react-dnd').DropTarget;
  const { pick } = require('lodash/fp');
  /**
   * A higher-order component that make a react component becomes droppable
   * @param  {ReactComponent} Component
   * @param  {String} types - This drop target will only react to the items produced by the drag sources of the specified type or types.
   * @param  {Object} options - Set of drop behaviors
   * @return {DroppableComponent}
   * @example
   *    var types = {
   *      CARD: 'CARD',
   *      DUMMY: 'DUMMY'
   *    };
   *
   *    var targetOptions = {
   *      drop: function (props, monitor, component) { },
   *      canDrop: function (props, monitor) { },
   *      ...
   *     };
   *    var InnerBox = require('./Box');
   *    var Box = droppable([types.CARD, types.DUMMY], targetOptions)(InnerBox);
   * 		...
   * 		<Box store={items} />
   */
  function droppable(types, options) {
    return function(Component) {
      /**
       * The collecting function.
       * Specifies which props to inject into your component. It should return a plain object of the props to inject into your component.
       * @param  {DropTargetConnector} connect
       * @param  {DropTargetMonitor} monitor
       * @return {Object}
       */
      function collect(connect, monitor) {
        return {
          connectDropTarget: connect.dropTarget(),
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop(),
          item: monitor.getItem(), // A plain object representing the currently dragged item.
          canAccess: options.canAccess, // Handle can access callback.
          itemType: monitor.getItemType()
        };
      }

      /**
       * Build drop target specifications.
       * React dnd only accepts some spec methods.
       * @return {Object}
       */
      function specOptions() {
        return  pick(['canDrop', 'hover', 'drop'], options);
      }

      var DroppableComponent = React.createClass({
        componentDidMount: function() {
          this.props.connectDropTarget(ReactDOM.findDOMNode(this));
        },
        render: function() {
          var connectDropTarget = this.props.connectDropTarget;

          var getRef = function(instance) {
            return connectDropTarget(ReactDOM.findDOMNode(instance));
          };

          return <Component {...this.props} ref={getRef} />;
        }
      });

      return m.observer(DropTarget(types, specOptions(), collect)(DroppableComponent));
    };
  }

  module.exports = droppable;
})();



// WEBPACK FOOTER //
// ./ui/share/components/hoc/Izenda.Droppable.jsx